import { render, staticRenderFns } from "./StartData.vue?vue&type=template&id=77bc7a9e&scoped=true&"
import script from "./StartData.vue?vue&type=script&lang=js&"
export * from "./StartData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc7a9e",
  null
  
)

export default component.exports